import React from 'react';
import {
    FormHelp,
    Label,
    LabeledControl,
    Radio,
} from '@zillow/constellation';

const rentByOptions = [
    {
        id: 'property-owner',
        label: 'Property Owner',
        formDataKey: 'owner',
    },
    {
        id: 'broker',
        label: 'Management company or broker',
        formDataKey: 'agent',
    },
    {
        id: 'tenant',
        label: 'Tenant',
        formDataKey: 'tenant',
    },
];

const ForRentBy = (props) => {
    const { formData, immediateUpdateAndSave, errorObj } = props;
    return (
        <div className="forRentBy">
            <Label required={true}>For rent by</Label>
            {rentByOptions.map(option => (
                <LabeledControl
                    key={`contact-${option.id}`}
                    controlId={`LabeledControl-contact-${option.id}`}
                    data-test={`contact-${option.id}`}
                    label={<Label>{option.label}</Label>}
                    control={(
                        <Radio
                            name="LabeledControl-contact"
                            checked={formData.forRentBy === option.formDataKey}
                            onChange={() => immediateUpdateAndSave('forRentBy', option.formDataKey)}
                        />
                    )}
                />
            ))}
            {errorObj.forRentBy && (
                <FormHelp error={true}>{errorObj.forRentBy}</FormHelp>
            )}
        </div>
    );
};

export { ForRentBy };
